export default __webpack_public_path__ + "static/whitstable-map-img-43abe993f6af93d94b973cdecc2ad3f0.jpg";